import React from 'react';
import CircularProgress from 'views/components/core/CircularProgress';

const VARIANTS = {
  primary: 'btn-primary',
  secondary: 'btn-secondary',
  'primary-gray': 'btn-primary-gray',
  gray: 'btn-gray',
  large: 'btn-lg',
  small: 'btn-sm',
};

const styles = {
  container: {
    position: 'relative',
  },
  circularProgress: {
    position: 'absolute',
    left: '50%',
    top: '50%',
  },
};

const LoadingButton = ({ variant, loading, disabled, ...props }) => {
  let className = '';
  if (variant) {
    className = variant.split(' ').reduce((className, type) => {
      return `${className} ${VARIANTS[type] || type}`;
    }, 'btn');
  }

  const iconSize = 20;

  return (
    <div style={styles.container}>
      <button
        className={className}
        {...props}
        disabled={disabled || loading}
        style={{
          '@keyframes circularRotate': {
            '100%': {
              transform: 'rotate(360deg)',
            },
          },
          ...props?.style,
        }}
      >
        {props.children}
      </button>
      {loading && (
        <CircularProgress
          style={{
            ...styles.circularProgress,
            marginTop: -iconSize / 2,
            marginLeft: -iconSize / 2,
          }}
          size={iconSize}
        />
      )}
    </div>
  );
};

export default LoadingButton;
